const CODE_RE = /^([A-Za-z]{1,2})(\d*)[.)]\s*/;

export const groupMinistries = (list) => {
  const groups = [];
  const byKey = {};
  const other = { key: "_other", main: null, subs: [] };
  list.forEach((m) => {
    const match = (m.name || "").trim().match(CODE_RE);
    if (!match) { other.subs.push(m); return; }
    const key = match[1].toUpperCase();
    if (!byKey[key]) { byKey[key] = { key, main: null, subs: [] }; groups.push(byKey[key]); }
    if (!match[2] && !byKey[key].main) byKey[key].main = m;
    else byKey[key].subs.push(m);
  });
  return other.subs.length ? [...groups, other] : groups;
};

export const groupTitle = (g) => (g.main ? g.main.name : g.key === "_other" ? "Other Ministries" : `Group ${g.key}`);
